import owd from 'owd/owd';

export default class Zoom extends owd.Component {
	init() {
        this.isEnabled = !Modernizr.touch;

        this.vars = {};
        this.vars.vw = this.dom.$window.width();
        this.vars.vh = this.dom.$window.height();
        this.$modal = $('<div class="zoom-modal">');
        this.$modal.css({
            display: 'none'
        });
        this.$modal.appendTo(this.dom.$body);

        this.$element.parent().addClass('no-ajax');

        this.bind();
        this.reposition();
	}


	bind() {
        this.dom.$body.on('click', this.$modal, (e) => {
            // e.preventDefault();

            if (this.isOpened) {
                this.$image = undefined;
                this.$modal.css({
                    pointerEvents: 'none'
                }).transition({
                    opacity: 0
                }, 400, 'ease-out', () => {
                    this.isOpened = false;
                    this.$modal.css({
                        display: 'none'
                    });
                });
            }
        });

        this.on('mousemove', this.dom.$body, (e) => {
            if (this.isEnabled) {
                this.vars.mouseX = e.clientX;
                this.vars.mouseY = e.clientY;

                this.reposition();
            }
        });

        this.on('resize', this.dom.$window, (e) => { // ready
            if (this.isEnabled) {
                this.vars.vw = this.dom.$window.width();
                this.vars.vh = this.dom.$window.height();

                this.reposition();
            }
        });

        this.dom.$body.on('click', '[data-zoom]', (e) => {
    
            if (this.isEnabled && !this.isOpened && !$(e.target).parent().hasClass('no-ajax')) {
                e.preventDefault();
                e.stopPropagation();                
                this.open(
                    this.$element.attr('href'),
                    this.$element.data('zoom').split('x')[0],
                    this.$element.data('zoom').split('x')[1]
                    );
            } 
        });
    }
    

    reposition() {
        if (this.$image !== undefined && this.vars.naturalHeight && this.vars.naturalWidth) {
            const actualHeight = this.vars.vw * this.vars.naturalHeight / this.vars.naturalWidth;

            if (actualHeight <= this.vars.vh) {
                this.$image.css({
                    y: (this.vars.vh - actualHeight) / 2
                });
            } else {
                this.$image.css({
                    y: (this.vars.vh - actualHeight) * (this.vars.mouseY / this.vars.vh)
                });
            }
        }
    }

    open(src, width, height) {
        this.$modal.children().remove();
        this.$modal.css({
            display: 'block',
            opacity: 0,
            pointerEvents: 'auto'
        }).transition({
            opacity: 1
        }, 400, 'ease-out', () => {
            this.isOpened = true;
        });

        this.vars.naturalWidth = width;
        this.vars.naturalHeight = height;

        this.$image = $('<img>');
        this.$image.appendTo(this.$modal);
        this.$image.css({
            opacity: 0
        }).one('load', () => {
            this.vars.naturalWidth = this.$image[0].naturalWidth;
            this.vars.naturalHeight = this.$image[0].naturalHeight;
            this.reposition();
            this.$image.transition({
                opacity: 1
            }, 400, 'ease-out');
        }).attr('src', src);

        this.reposition();
    }

	destroy() {
        super.destroy();
        
        this.$modal.remove();
	}
}

owd.registerComponent('zoom', {
	component: Zoom
});
